import { Info } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import React from "react";

interface InfoIconProps {
  onClick: () => void;
  textColor?: string;
  backgroundColor?: string;
  size?: number;
  fontSize?: number;
}

const InfoIcon: React.FC<InfoIconProps> = ({
  onClick,
  textColor = "#E7EDFF",
  backgroundColor = "black",
  size = 18,
  fontSize = 32,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        border: "none",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        backgroundColor: textColor,
        borderRadius: 12,
      }}
    >
      <IconButton onClick={() => onClick()}>
        <Info sx={{ color: backgroundColor, fontSize }} />
      </IconButton>
    </Box>
  );
};

export default InfoIcon;
